// Fuente única de los roles del onboarding. `value` es lo que se persiste en
// la membresía UserCompany (y valida el backend contra UserCompany.ROLE_CHOICES);
// `emoji` es el marcador visual. El select del registro y la vista del rol en
// el menú de usuario consumen ESTA lista, no duplican el mapa.
export const ROLES = [
    { value: "Gerente", emoji: "👔" },
    { value: "Administrativo", emoji: "📋" },
    { value: "Contador", emoji: "📊" },
    { value: "Director", emoji: "🎯" },
    { value: "Asesor", emoji: "💼" },
    { value: "Inversionista", emoji: "💰" },
    { value: "Banco", emoji: "🏦" },
    { value: "Otro", emoji: "🧩" },
];

// Shape `{ value, label }` con el emoji embebido — lo que espera el <select>.
export const ROLE_OPTIONS = ROLES.map((role) => ({
    value: role.value,
    label: `${role.emoji} ${role.value}`,
}));

// Emoji de un rol por su `value` (vacío si no matchea).
export const roleEmoji = (value) => {
    const role = ROLES.find((item) => item.value === value);
    return role ? role.emoji : "";
};

// Etiqueta "emoji value" para mostrar un rol ya guardado (sin emoji si no hay).
export const roleLabel = (value) => {
    if (!value) return "";
    const emoji = roleEmoji(value);
    return emoji ? `${emoji} ${value}` : value;
};
